import { render } from "./FormshopView.vue?vue&type=template&id=0d533401&scoped=true"
import script from "./FormshopView.vue?vue&type=script&lang=js"
export * from "./FormshopView.vue?vue&type=script&lang=js"

import "./FormshopView.vue?vue&type=style&index=0&id=0d533401&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\h_fujii\\Desktop\\task-app2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d533401"]])

export default __exports__